import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useQuery } from "@tanstack/react-query";

export const giftReceiptRequestsCountQueryKey = [
  "giftReceiptRequestsCount",
] as const;

/**
 * Count of unresolved gift receipt requests for the current team. Disabled
 * (returns undefined) unless gift receipts are enabled in team settings.
 */
export function useGiftReceiptRequestsCount(): number | undefined {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const team = useRequiredContext(TeamContext);

  const query = useQuery({
    queryKey: [...giftReceiptRequestsCountQueryKey, String(team._id)],
    queryFn: async ({ signal }) => {
      const response = await rpcClient.getGiftReceiptRequestsCount(
        {},
        { signal },
      );
      return response.total;
    },
    enabled: !!team.settings.returns?.enableGiftReceipts,
  });

  return query.data;
}
